'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global services*/
/*global hoursInTime*/
/*global diffTime*/
/*global formatedTime*/
/*global roundToDecimals*/
/*global formatTimeHM*/
/*global formatTimeDM*/
function Stopwatches(containerID) {
  this.containerID = containerID;
  this.$container = null;

  this.init();
}

Stopwatches.prototype = $.extend({}, {
  constructor: 'Stopwatches',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.stopwatch-start', function () {
      _this.addStopwatch($(this).data('job_queue_rid'), $(this).data('project_title'), $(this).data('task_title'));
      return false;
    });

    $('body').on('click', '#' + _this.containerID + ' .stopwatch-stop', function () {
      _this.stopStopwatch($(this).closest('.stopwatch'));
      return false;
    });

    $('body').on('click', '#' + _this.containerID + ' .stopwatch-pause', function () {
      _this.pauseStopwatch($(this).closest('.stopwatch'));
      return false;
    });

    $('body').on('click', '#' + _this.containerID + ' .stopwatch-play', function () {
      _this.playStopwatch($(this).closest('.stopwatch'));
      return false;
    });

    $('body').on('click', '#' + _this.containerID + ' .stopwatch-remove', function () {
      _this.removeStopwatch($(this).closest('.stopwatch'));
      return false;
    });
  },

  //----------------------------------------------------------------------------

  getStopwatchTime: function getStopwatchTime(timeStart, pauseTime, paused, pauseStart) {
    if (paused) {
      pauseTime += diffTime(pauseStart, new Date());
    }

    return diffTime(timeStart, new Date()) - pauseTime;
  },

  getStopwatchHTML: function getStopwatchHTML() {
    var stopwatch = '<div class="stopwatch">';
    stopwatch +=      '<input type="hidden" name="job_queue_rid" value="" />';
    stopwatch +=      '<input type="hidden" name="time_start" value="" />';
    stopwatch +=      '<input type="hidden" name="pause_time" value="" />';
    stopwatch +=      '<input type="hidden" name="pause_start" value="" />';
    stopwatch +=      '<input type="hidden" name="stopwatch_id" value="" />';
    stopwatch +=      '<div class="stopwatch-title">';
    stopwatch +=        '<span class="stopwatch-title-project"></span>';
    stopwatch +=        ' - ';
    stopwatch +=        '<span class="stopwatch-title-task"></span>';
    stopwatch +=      '</div>';
    stopwatch +=      '<div class="stopwatch-time">';
    stopwatch +=        '<span class="stopwatch-timer">0:00:00</span>';
    stopwatch +=        '<span class="stopwatch-start-time-wrapper">';
    stopwatch +=          '(';
    stopwatch +=            '<span class="stopwatch-start-time">00.00. 00:00</span>';
    stopwatch +=          ')';
    stopwatch +=        '</span>';
    stopwatch +=      '</div>';
    stopwatch +=      '<div class="stopwatch-buttons">';
    stopwatch +=        '<a class="stopwatch-pause" href="#" title="' + services.get('translator').trans('stopwatch.pause') + '"><span class="glyphicon glyphicon-pause"></span></a>';
    stopwatch +=        '<a class="stopwatch-play" href="#" title="' + services.get('translator').trans('stopwatch.play') + '"><span class="glyphicon glyphicon-play"></span></a>';
    stopwatch +=        '<a class="stopwatch-stop" href="#" title="' + services.get('translator').trans('stopwatch.stop') + '"><span class="glyphicon glyphicon-stop"></span></a>';
    stopwatch +=        '<a class="stopwatch-remove" href="#" title="' + services.get('translator').trans('stopwatch.remove') + '"><span class="glyphicon glyphicon-trash"></span></a>';
    stopwatch +=      '</div>';
    stopwatch +=    '</div>';

    return stopwatch;
  },

  createStopwatch: function createStopwatch(jobQueueRID, projectTitle, taskTitle) {
    var _this = this;

    var $stopwatch = $(_this.getStopwatchHTML());
    $stopwatch.find('[name="job_queue_rid"]').val(jobQueueRID);
    $stopwatch.find('.stopwatch-title-project').html(projectTitle);
    $stopwatch.find('.stopwatch-title-task').html(taskTitle);
    $stopwatch.addClass('stopwatch-stoped');
    $stopwatch.addClass('stopwatch-paused');

    _this.$container.append($stopwatch);

    return $stopwatch;
  },

  startStopwatch: function startStopwatch($stopwatch, timeStart, stopwatchId, pauseTime, paused, pauseStart) {
    var _this = this;

    var time = formatedTime(_this.getStopwatchTime(timeStart, pauseTime, paused, pauseStart));

    $stopwatch.find('[name="time_start"]').val(timeStart);
    $stopwatch.find('[name="pause_time"]').val(pauseTime);
    $stopwatch.find('[name="pause_start"]').val(pauseStart);
    $stopwatch.find('[name="stopwatch_id"]').val(stopwatchId);
    $stopwatch.find('.stopwatch-timer').text(time);
    $stopwatch.find('.stopwatch-start-time').text(formatTimeDM(timeStart) + ' ' + formatTimeHM(timeStart));
    $stopwatch.removeClass('stopwatch-stoped');

    if (!paused) {
      $stopwatch.removeClass('stopwatch-paused');
    }

    return _this;
  },

  addStopwatch: function addStopwatch(jobQueueRID, projectTitle, taskTitle, callBack) {
    var _this = this;

    var $stopwatch = _this.createStopwatch(jobQueueRID, projectTitle, taskTitle);
    var timeStart = (new Date()).getTime();

    blockElement($stopwatch);
    $.get(services.get('router').path('stopwatch_add'), { jobQueueRID: jobQueueRID, projectTitle: projectTitle, taskTitle: taskTitle, timeStart: timeStart }, function (res) {
      unBlockElement($stopwatch);

      if (res.msg === 'SUCCESS') {
        _this.startStopwatch($stopwatch, timeStart, res.data.stopwatch_id, 0, false, 0);

        if (callBack) {
          window[callBack]();
        }
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  stopStopwatch: function stopStopwatch($stopwatch) {
    var _this = this;

    _this.removeStopwatch($stopwatch, function () {
      var time = _this.getStopwatchTime(parseInt($stopwatch.find('[name="time_start"]').val()), parseInt($stopwatch.find('[name="pause_time"]').val()), $stopwatch.hasClass('stopwatch-paused'), parseInt($stopwatch.find('[name="pause_start"]').val()));
      var hours = roundToDecimals(hoursInTime(time), 3);

      if (services.has('project-timesheet')) {
        services.get('project-timesheet').showEditForm(null, null, hours, $stopwatch.find('[name="job_queue_rid"]').val(), null, null);
      }

      $stopwatch.remove();
    });

    return _this;
  },

  pauseStopwatch: function pauseStopwatch($stopwatch) {
    var _this = this;

    var pauseStart = (new Date()).getTime();

    $stopwatch.addClass('stopwatch-paused');
    blockElement($stopwatch);
    $.get(services.get('router').path('stopwatch_pause', { stopwatchId: $stopwatch.find('[name="stopwatch_id"]').val() }), { time: pauseStart }, function (res) {
      unBlockElement($stopwatch);

      if (res.msg === 'SUCCESS') {
        $stopwatch.find('[name="pause_start"]').val(pauseStart);
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  playStopwatch: function playStopwatch($stopwatch) {
    var _this = this;

    blockElement($stopwatch);
    $.get(services.get('router').path('stopwatch_play', { stopwatchId: $stopwatch.find('[name="stopwatch_id"]').val() }), { time: (new Date()).getTime() }, function (res) {
      unBlockElement($stopwatch);

      if (res.msg === 'SUCCESS') {
        $stopwatch.removeClass('stopwatch-paused');
        $stopwatch.find('[name="pause_time"]').val(res.data.pause_time);
        $stopwatch.find('[name="pause_start"]').val(0);
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  removeStopwatch: function removeStopwatch($stopwatch, callBack) {
    var _this = this;

    $stopwatch.addClass('stopwatch-stoped');
    blockElement($stopwatch);
    $.get(services.get('router').path('stopwatch_remove', { stopwatchId: $stopwatch.find('[name="stopwatch_id"]').val() }), function (res) {
      unBlockElement($stopwatch);

      if (res.msg === 'SUCCESS') {
        if (callBack) {
          callBack();
        } else {
          $stopwatch.remove();
        }
      } else {
        services.get('notifications').viewErrorMessage();
      }
    });

    return _this;
  },

  runStopwatch: function (stopwatchId, jobQueueRID, projectTitle, taskTitle, timeStart, pauseTime, paused, pauseStart) {
    var _this = this;

    var $stopwatch = _this.createStopwatch(jobQueueRID, projectTitle, taskTitle);
    _this.startStopwatch($stopwatch, timeStart, stopwatchId, pauseTime, paused, pauseStart);

    return _this;
  },

  incStopwatches: function incStopwatches() {
    var _this = this;

    _this.$container.find('.stopwatch:not(.stopwatch-stoped, .stopwatch-paused)').each(function () {
      var $stopwatch = $(this);
      var timeStart = parseInt($stopwatch.find('[name="time_start"]').val());
      var pauseTime = parseInt($stopwatch.find('[name="pause_time"]').val());
      var time = formatedTime(_this.getStopwatchTime(timeStart, pauseTime));
      $stopwatch.find('.stopwatch-timer').text(time);
      $stopwatch.find('.stopwatch-start-time').text(formatTimeDM(timeStart) + ' ' + formatTimeHM(timeStart));
    });

    return _this;
  },

  init: function init() {
    var _this = this;

    _this.$container = $('<div>', { id: _this.containerID, class: 'stopwatch-wrapper' });
    $('body header .navbar').append(_this.$container);
    _this.registerCallbacks();

    setInterval(function () {
      _this.incStopwatches();
    }, 1000);
  }
});
